import React from 'react';
import classes from './Footer.module.scss'

function Fotter(props) {
    return (
        <div className={classes['footer-section']}>


            <div className={classes['icon']}></div>
            {/*<div className={classes['paragraphs']}>*/}
            {/*    <h3>| Menu</h3>*/}
            {/*    <h4>Home</h4>*/}
            {/*    <p>News and Events</p>*/}
            {/*    <p>Project</p>*/}
            {/*    <p>UAV</p>*/}
            {/*    <h5>UAV</h5>*/}
            {/*    <p>AW5 AW21 AWC2</p>*/}
            {/*    <p>AW6 AW25.glb</p>*/}
            {/*    <p>AW15 AW29</p>*/}
            {/*    <p>AW17 AWC1</p>*/}
            {/*    <h2>Project</h2>*/}
            {/*    <h2>News</h2>*/}
            {/*    <h2>About us</h2>*/}
            {/*    <h2>Contact</h2>*/}

            {/*</div>*/}

            <div className={classes['contact-info']}>
                <p>| Contact info</p>
                <p>
                    <div className={classes['phone-icon']}></div>
                    &nbsp;&nbsp;  +374 77 513 344
                </p>
                <p>
                    <div className={classes['mail-icon']}></div>
                    &nbsp;&nbsp; info@airworker.aero
                </p>
                <p>
                    <div className={classes['location-icon']}></div>
                    &nbsp;&nbsp;  Yerevan Armenia
                </p>


                <div className={classes['iconses']}>
                    <a
                        href="https://www.facebook.com/share/1AAuFJ8UNP/?mibextid=wwXIfr"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes['facebook-icon']}
                    ></a>
                    <a
                        href="https://www.linkedin.com/company/airworker/posts/?feedView=all"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes['linkedin-icon']}
                    ></a>
                    <a
                        href="https://youtube.com/@airworker8704?si=bgdr2jw0aZcdDH2q"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes['youtube-icon']}
                    ></a>
                </div>


            </div>
            <div className={classes['bg-img']}></div>

            <div className={classes['hr']}></div>
        </div>
    );
}

export default Fotter;